import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Game, MediaItem } from '@mtgame/core';

@Component({
  selector: 'mtg-game-media',
  templateUrl: './game-media.component.html',
  styleUrls: ['./game-media.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GameMediaComponent implements OnChanges {
  @Input()
  game: Game;
  @Input()
  mediaRoute: string;
  photos: MediaItem[] = [];
  video: MediaItem[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.game && this.game) {
      this.photos = this.game.media.filter(item => !item.videoUrl);
      this.video = this.game.media.filter(item => item.videoUrl);
    }
  }
}
